import store from "../../../../store";
import sb_doc_edit from "./sb_doc_edit.vue";

window.SB_DOC_EDIT =  new Vue({
    store,
    name : "SB_DOC_EDIT",
    el: '#sb_doc_edit',

    data () {
        return {
            showModal: false,
        }
    },
    created () {

    },

    components : {
        sb_doc_edit
    }
});
